import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Nav2 from '../../Nav2/Nav2';
import BannerAnak from '../CategoryBanner/banneranak';
import Content from '../Content/Content';
import '../Pendidikan/category.css'




const Anak = () => {
    const [content, setContent] = useState([])

    const fetchAnak = async () => {
        const { data } = await axios.get(
            'https://weshare-heroku.herokuapp.com/api/weShare/category/'
        )
        setContent(data.data[2].OpenDonations)
    }

    useEffect(() => {
        fetchAnak()
    }, [])

    return (
        <div>
            <Nav2 />
            <BannerAnak />
            <div className="title-category">
                <div className="anak">
                    {
                        content && content.map((c) => (
                            <Content
                                key={c.id}
                                name={c.donationName}
                                need={c.donationNeeded}
                                expired={c.expiredDate}
                                image={c.image}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default Anak;
